import React from 'react';
import { useBloodGlucoseDatapoints } from 'hooks/useBloodGlucoseDatapoints';
import { useLoggedInUser } from 'features/auth/hooks/useAuthData';
import { BloodSugarDetailView, BloodSugarDetailViewProps } from './BloodSugarDetailView';

export type BloodSugarDetailPageProps = Pick<
  BloodSugarDetailViewProps,
  'onBack' | 'onDownload' | 'isDownloading'
>;

// Fetches the member's blood glucose readings; BloodSugarDetailView owns the loading, error and
// empty states.
export const BloodSugarDetailPage = (props: BloodSugarDetailPageProps) => {
  const user = useLoggedInUser();
  const { datapoints, isLoading, isError } = useBloodGlucoseDatapoints(user?.id);

  return (
    <BloodSugarDetailView
      {...props}
      datapoints={datapoints}
      isLoading={isLoading}
      isError={isError}
    />
  );
};
